<template>
  <q-checkbox :value="value"
              :label="label"
              :disable="disable"
              :color="color"
              :keep-color="keepColor"
              :size="size"
              :dense="dense"
              v-on="$listeners">
    <template>
      <slot v-if="!label"/>
    </template>
  </q-checkbox>
</template>

<script>
export default {
  name: 'RCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    label: String,
    color: String,
    keepColor: Boolean,
    size: String,
    dense: Boolean,
  },
};
</script>
